import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";
import { Modal, message } from "antd";
import { observer } from "mobx-react-lite";
import { globalModel } from "../../global/GlobalModel";
import { CustomerServiceChatPanel } from "./CustomerServiceChatPanel";
import { CustomerServiceChatModel } from "./CustomerServiceChatModel";
import { CustomerServiceFloatEntry } from "./CustomerServiceEntry";
import { CS_AVATAR_URL, CS_DISPLAY_NAME } from "./CustomerServiceChatTypes";
import "./CustomerServiceChatStyle.css";

export type CustomerServiceChatModalsApi = {
  /** 已登录则打开；未登录提示并弹登录框 */
  openCustomerServiceChat: () => void;
};

const Ctx = createContext<CustomerServiceChatModalsApi | null>(null);

export function useCustomerServiceChatModal(): CustomerServiceChatModalsApi {
  const v = useContext(Ctx);
  if (!v) {
    throw new Error("useCustomerServiceChatModal must be used inside provider");
  }
  return v;
}

const ModalBody = observer(function ModalBody(props: { open: boolean }) {
  const model = useMemo(() => new CustomerServiceChatModel(), [props.open]);
  if (!props.open) return null;
  return <CustomerServiceChatPanel model={model} />;
});

export function CustomerServiceChatModalProvider(props: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  const openCustomerServiceChat = useCallback(() => {
    if (!globalModel.isLoggedIn) {
      message.info("请先登录后再联系平台客服");
      globalModel.openLoginModal();
      return;
    }
    setOpen(true);
  }, []);

  const api = useMemo(
    () => ({
      openCustomerServiceChat,
    }),
    [openCustomerServiceChat]
  );

  return (
    <Ctx.Provider value={api}>
      {props.children}
      <CustomerServiceFloatEntry onClick={openCustomerServiceChat} />
      <Modal
        className="lf-cs-modal"
        title={
          <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
            <img src={CS_AVATAR_URL} alt="" width={24} height={24} style={{ borderRadius: 4 }} />
            {CS_DISPLAY_NAME}
          </span>
        }
        open={open}
        footer={null}
        width={850}
        destroyOnHidden
        onCancel={() => setOpen(false)}
      >
        <ModalBody open={open} />
      </Modal>
    </Ctx.Provider>
  );
}
